import React from "react";

import { getTranslatedGameName } from "@/modules/commonMobile";
import "./index.scss";
import {
	IGameObjectType,
	ILanguageType
} from "@/types/GlobalTypes";

interface IProps {
	games: IGameObjectType;
	langdata: ILanguageType;
	orientation: string;
	
	activeGamePcode: string;

	mobileHome?: boolean;
	desktop?: boolean;

	setActiveGame: (e: any) => void;

	//Only on desktop
	togglePopupResultHistory?: (e: any) => void;
}

export default class PopupResultHistoryGameList extends React.Component<IProps> {
	render() {
		const games = this.props.games,
			mobileHome = this.props.mobileHome,
			desktop = this.props.desktop,
			langdata = this.props.langdata;

		return (
			<div>
				<div key="PTH_header" className="popup-header">
					Result History
					<i className={"sl-ic-close close"} onClick={this.props.togglePopupResultHistory} />
				</div>
				{/* SIDE GAME MENU */}
				{/* <div className={"lobby-mobile-game-result-history-popup-list" +
					(mobileHome ? " mobile-home" : "") +
					(desktop ? " desktop" : "") +
					(" " + this.props.orientation)
				}>
					{
						Object.keys(games).map((pcode) => {
							const translatedGameName = getTranslatedGameName(langdata, pcode, true);

							return (
								<div key={"LM_GRH_" + pcode}

									{...{game: pcode}}

									className={
										(pcode === this.props.activeGamePcode ? "active" : "") +
										(translatedGameName.length > 16 ? " long-text" : "")
									}
									onClick={this.props.setActiveGame}>

									<div>
										{ translatedGameName }
									</div>
								</div>
							);
						})
					}
				</div> */}
				{/*END SIDE GAME MENU */}
			</div>
		);
	}
}